import { render, staticRenderFns } from "./actionButton.vue?vue&type=template&id=85492412&scoped=true"
import script from "./actionButton.vue?vue&type=script&lang=js"
export * from "./actionButton.vue?vue&type=script&lang=js"
import style0 from "./actionButton.vue?vue&type=style&index=0&id=85492412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85492412",
  null
  
)

export default component.exports